export enum ProjectTemplateStatus {
  Draft = 0,
  Published = 1,
}
